import React from "react"
import { ProgressBar } from "../view/Progress"
import { MachineContext } from "../fsm/useMachine"
import { UPLOAD_DRAFTS, FlowMachineContext } from "../fsm/types"
import { State } from "xstate"
import { XCircle, AlertTriangle } from "react-feather"
import { useEditorCoordinator } from "../text_editor/editorCoordinator"
import { FlowWindow } from "../utils/globals"

declare let window: FlowWindow;

/**
 * Check if there are any unresolved image placeholders in the content layer.
 * Returns count of images still generating.
 */
function getUnresolvedImageCount(): number {
    const content = window.flowboard?.content || window.flow_json?.flowboard?.content;
    if (!content?.presentation?.screens) return 0;

    let count = 0;
    for (const screen of content.presentation.screens) {
        for (const block of screen.blocks || []) {
            if (block.type === 'image-placeholder' && !block.resolvedImageUrl) {
                count++;
            }
        }
    }
    return count;
}

interface Props {
    publishArgs: { asDraft: boolean, forceToView: boolean }
    close(): void
}

export const UploadModal: React.FC<Props> = ({ publishArgs, close }) => {
    const [current, send, service] = React.useContext(MachineContext)
    const { count, total } = current.context.publishConfig
    const [currIdx, setCurrIdx] = React.useState(Math.max(current.context.publishConfig.count, 1));
    const [text, setText] = React.useState(`Uploading File ${Math.max(currIdx, 1)} of ${total + 1}`);
    const { flushAllPendingUpdates } = useEditorCoordinator()


    React.useEffect(() => {
        console.debug("SEE MODAL!")
        // CRITICAL: Flush all pending text editor updates BEFORE saving
        console.log("[UploadModal] Flushing all pending text updates before save")

        // Await the flush to complete before sending upload
        flushAllPendingUpdates().then(() => {
            console.log("[UploadModal] All updates flushed, starting upload")
            send({ type: UPLOAD_DRAFTS, ...publishArgs });
        })
    }, [flushAllPendingUpdates])

    React.useEffect(() => {
        console.info("[UploadModal] count changed:", count, "total:", total, "currIdx:", currIdx)
        setCurrIdx(curr => {
            const newIdx = Math.max(count, curr);
            console.info("[UploadModal] setCurrIdx:", curr, "->", newIdx);
            return newIdx;
        })
        setText(() => {
            const text = `Uploading File ${Math.max(count, 1)} of ${total + 1}`;
            console.info("[UploadModal] setText:", text);
            return text;
        })
        // if (publishArgs.asDraft && count >= total) {
        //     close()
        // }
    }, [count])

    React.useEffect(() => {
        const subscription = service.subscribe((state: State<FlowMachineContext, any, {}>) => {
            if (state.matches({ logic: "complete" })) {
                setCurrIdx(total)
                setText("Finishing Up...")
            }
            else if (state.context.drafts.length == 0) {
                setCurrIdx(() => total + 1)
                setText("Finishing Up...")
                close()
            }
        });

        return subscription.unsubscribe;
    }, [service]); // note: service should never change


    return (
        <div className="upload-modal-content border-rad_10 flex-column-center" >
            <div className="flex-end">
                <span onClick={close}>
                    <XCircle className="feather" />
                </span>
            </div>
            <ProgressBar percentage={(currIdx / (total + 1)) * 100} />
            <span>
                {text}
            </span>
        </div>
    )
}

UploadModal.displayName = "Upload Modal"
export default UploadModal



